import { FC } from 'react';
import s from './rubyAmount.module.scss';
import { Input } from '@components/UIKit/Input/Input';
import { useTranslation } from '@hooks/useTranslation';
import { Currency } from '@components/UIKit/Currency/Currency';
import { profile } from '@specs/specs';
import { minRubyWithdrawAmount } from '@specs/constants';
import { StateType } from '@components/Pages/PaymentsPages/Withdraw/Form/Form';
import { formatNumber } from '@helpers/arToysHelpers';
import cn from 'classnames';
import { formatRubyAmount } from '@specs/helpers';
import parse from 'html-react-parser';
interface Props {
  price: StateType['price'];
  changeFromData: <T extends keyof StateType>(key: T, value: StateType[T]) => void;
  ruby: profile['ruby'];
}
export const RubyAmount: FC<Props> = ({
  price,
  changeFromData,
  ruby
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.rubyAmount} data-sentry-component="RubyAmount" data-sentry-source-file="RubyAmount.tsx">
            <div className={s.rubyAmount__head}>
                <div className={s.rubyAmount__title}>
                    {tr({
          id: 'withdraw.page.manually.title'
        })}
                </div>
                <div className={cn(s.rubyAmount__description, formatRubyAmount(ruby) < minRubyWithdrawAmount && s.rubyAmount__description_error)}>
                    {parse(tr({
          id: 'withdraw.page.min.withdrawal.description'
        }, {
          count: minRubyWithdrawAmount
        }))}
                </div>
                <div className={cn(s.rubyAmount__balance, formatRubyAmount(ruby) < minRubyWithdrawAmount && s.rubyAmount__balance_error)}>
                    {tr({
          id: 'withdraw.page.your.balance'
        })}
                    {' '}
                    <span>
                    <Currency currency={'RUBY'} amount={ruby} data-sentry-element="Currency" data-sentry-source-file="RubyAmount.tsx" />
                    </span>
                </div>
            </div>
            <div className={s.rubyAmount__row}>
                <Input name={'price'} value={price} onPrint={value => {
        if (Number(value) <= 0) return changeFromData('price', '');
        if (Number(value) >= ruby / 100) return changeFromData('price', ruby / 100);
        changeFromData('price', Number(value));
      }} type={'number'} max={ruby} placeholder={tr({
        id: 'withdraw.page.input.amount.ruby.placeholder'
      })} data-sentry-element="Input" data-sentry-source-file="RubyAmount.tsx" />
                <div className={s.rubyAmount__sum}>
                    = ${formatNumber(Number(price) * 100)}
                </div>
            </div>

        </div>;
};